document.addEventListener("DOMContentLoaded", function () {
  // to top button
  let scrollToTopButton = document.getElementById("js-top");
  if (scrollToTopButton) {
    window.onscroll = function () {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 300 ||
        document.documentElement.scrollTop > 300
      ) {
        scrollToTopButton.classList.add("show");
      } else {
        scrollToTopButton.classList.remove("show");
      }
    }
    // scrollToTopButton.onclick = function topFunction() {
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    // };
    scrollToTopButton.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }

  // sticky header
  const header = document.querySelector(".site-header");
  const toggleClass = "is-sticky";
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 100) {
      header.classList.add(toggleClass);
    } else {
      header.classList.remove(toggleClass);
    }
  });
  
  // add hover class to menu-items
  const menuItems = document.querySelectorAll(".lang .menu-item");
  menuItems.forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("hover");
    });
  });
  window.addEventListener("click", (event) => {
    const targetElement = event.target;
    const menuItemsArray = Array.from(menuItems);
    const isMenuItem = menuItemsArray.some((item) =>
      item.contains(targetElement)
    );
    if (!isMenuItem) {
      menuItems.forEach((item) => {
        item.classList.remove("hover");
      });
    }
  });

});
